/**
 * Rounds a number with any number of decimal places to two decimal places.
 *
 * @param number given number with any number of decimal places.
 * @returns number with decimal places.
 */
export default function to2DP(number: number): number {
  return Math.round(number * 100) / 100;
}
